import { render, staticRenderFns } from "./CalendarBase.vue?vue&type=template&id=1db895fe"
import script from "./CalendarBase.vue?vue&type=script&lang=ts"
export * from "./CalendarBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports